<template>
    <div class="row">
        <div class="card">
            <div class="card-header flex flex-col justify-between items-center">
                <h2>Lista de Sindicatos</h2>
                <router-link
                    to="/sistema/sindicatos/novo-sindicato"
                    class="btn btn-primary"
                >Novo Sindicato
                </router-link>
            </div>
            <!-- FILTROS -->
            <div>
                <validation-observer ref="forms" v-slot="{handleSubmit}">
                    <form class="form-group" @submit.prevent="handleSubmit(getSindicatos)">
                        <div class="flex items-start">
                            <validation-provider
                                name="CNPJ"
                                vid="cnpj"
                                v-slot="{errors}"
                                tag="div"
                                class="input-std form-text"
                            >
                                <input type="text" v-model="sindicatos.filtros.search" class="text-black mr-3" placeholder="Digite o CNPJ" v-mask="'##.###.###/####-##'">
                                <p class="errors text-sm">{{ errors[0] }}</p>
                            </validation-provider>
                            <button class="btn btn-primary ml-3" type="submit" style="height: 50px">Enviar</button>
                        </div>
                    </form>
                </validation-observer>
            </div>
            <!-- FILTROS -->
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="sindicatos.columns"
                    :rows="sindicatos.rows"
                    :totalRows="sindicatos.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum sindicato foi contratado.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-col"
                        >
                            <div
                                class="h-6 mb-2"
                                title="Editar Sindicato"
                                @click.prevent="
                                    () =>
                                        $router.push(
                                            '/sistema/sindicatos/editar-sindicato/' +
                                                props.row.id
                                        )
                                "
                            >
                                <svg-icon
                                    icon="pencil"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                            <div
                                class="h-6"
                                title="Excluir Sindicato"
                                @click="removerSindicato(props.row)"
                            >
                                <svg-icon
                                    icon="delete"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import {VueGoodTable} from "vue-good-table";
import { mask } from "vue-the-mask";

export default {
    name: "tabela-sindicatos",

    directives: { mask },
    components: {
        VueGoodTable
    },

    created() {
        this.getSindicatos();
    },

    data() {
        return {
            sindicatos: {
                columns: [
                    {label: "Cnpj", field: "cnpj"},
                    {label: "Nome", field: "nome_completo"},
                    {label: "Presidente", field: "nome_presidente"},
                    {label: "Cidade", field: "cidade"},
                    {label: "Email", field: "email"},
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    search: '',
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarSindicatos({page: params.currentPage});
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarSindicatos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarSindicatos({perPage: params.currentPerPage});
        },

        /**
         * Filtra os sindicatos conforme as mudanças
         * @param newProps
         */
        filtrarSindicatos(newProps) {
            this.sindicatos.filtros = Object.assign(
                {},
                this.sindicatos.filtros,
                newProps
            );
            this.getSindicatos();
        },

        getSindicatos() {
            this.axios("sindicatos", {
                params: {
                    search: this.sindicatos.filtros.search,
                    page: this.sindicatos.filtros.page,
                    per_page: this.sindicatos.filtros.perPage,
                    sortField: this.sindicatos.filtros.sort.field,
                    sortType: this.sindicatos.filtros.sort.type
                }
            }).then(response => {
                this.sindicatos.rows = response.data.sindicato.data;
                this.sindicatos.total = response.data.sindicato.total;
            });
        },

        removerSindicato(row) {
            this.$swal({
                title: "Excluir Sindicato",
                text: "Você deseja excluir este sindicato?",
                icon: "question",
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: "#6C9E1D",
                cancelButtonColor: "#E50053",
                cancelButtonText: "Não",
                confirmButtonText: "Sim"
            }).then(result => {
                if (result.value) {
                    this.axios
                        .delete(`/sindicatos/${row.id}`)
                        .then(response => {
                            this.$swal({
                                title: "Sucesso",
                                text: "O sindicato foi excluido com sucesso!",
                                icon: "success"
                            });
                            this.sindicatos.rows.splice(row.originalIndex, 1);
                        })
                        .catch(error => {
                            this.$swal({
                                title: "Algo de errado ocorreu",
                                text: error.response.data.message,
                                icon: "error"
                            });
                        });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.card-header {
    @media (min-width: 500px) {
        @apply flex-row;
    }
}
</style>
